var React = require('react');

function Ch (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#D52B1E","height":"320","width":"320","key":0}),React.createElement("rect",{"fill":"#fff","height":"60","width":"200","x":"60","y":"130","key":1}),React.createElement("rect",{"fill":"#fff","height":"200","width":"60","x":"130","y":"60","key":2})]);
}

Ch.defaultProps = {"viewBox":"0 0 320 320"};

module.exports = Ch;

Ch.default = Ch;
